import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppComponent } from 'src/app/app.component';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { CompanyDetailsComponent } from '../company-details.component';

@Component({
  selector: 'app-edit-branch',
  templateUrl: './edit-branch.component.html',
  styleUrls: ['./edit-branch.component.scss']
})
export class EditBranchComponent implements OnInit {

  @ViewChild('closeBtn') closeBtn: ElementRef;
  @Input() branchData: any

  editBranchForm: FormGroup;
  missingFieldMsg = false;
  errorMsg: boolean;

  constructor(private formBuilder: FormBuilder,
    private authService: AuthenticationService,
    private companyDetails: CompanyDetailsComponent, private appComp: AppComponent ) {
      this.editBranchForm = this.formBuilder.group({
        name: ["", Validators.required],
        contact: ["", Validators.required],
        address1: ["", Validators.required],
        address2: [""],
        city: ["", Validators.required],
        state: ["", Validators.required],
        zip: ["", Validators.required],
        phone: ["", Validators.required],
        email: ["", Validators.required],
        contactPhone: ["", Validators.required],
        contactEmail: ["", Validators.required],
        active: [null],
      });
    }

  ngOnInit() {
    
  }

  ngOnChanges() { 
    this.errorMsg = false;  
    if(this.branchData){
      this.editBranchForm.patchValue({
        name: this.branchData.name,
        contact: this.branchData.contact,
        address1: this.branchData.address1,
        address2: this.branchData.address2,
        city: this.branchData.city,
        state: this.branchData.state,
        zip: this.branchData.zip,
        phone: this.branchData.phone,
        email: this.branchData.email,
        contactPhone: this.branchData.contactPhone,
        contactEmail: this.branchData.contactEmail,
        active: this.branchData.active
      })
    }
    
  }

  editBranch(){
    this.appComp.loading = true;
    this.errorMsg = false;
    this.missingFieldMsg = false;
    if (this.editBranchForm.invalid) {
      this.missingFieldMsg = true;
      this.appComp.loading = false;
      return;
    }
    let formObj = this.editBranchForm.getRawValue();
    console.log(formObj);
    formObj.id = this.branchData.id;
    formObj.idCompany = this.branchData.idCompany;
    if(typeof formObj.active == "string"){
      formObj.active = formObj.active == 'true' ? true : false;
    }
    this.authService.editBranch(formObj).then(res=>{
      console.log(res);
      this.closeBtn.nativeElement.click();
      this.companyDetails.getCompanyDetails(this.companyDetails.companyId);
      this.appComp.loading = false;
    }, err =>{
      this.errorMsg = true;
      console.log(err);
      this.appComp.loading = false;
    })
  }

}
